import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAgencyApi, SetupAgencyApi, testSMTPApi, UpdateAgencyApi, validateSMTPApi, VerifyDomainApi, workspaceDetailsApi, workspaceTestEmailApi, workspaceUpdateApi, workspaceValidateSMTPApi, workspaceVerifyDomainApi, createWorkspaceWidgetDataApi, getWorkspaceWidgetDataApi, updateWorkspaceWidgetDataApi, workspaceWidgetReportDataApi, workspaceWidgetReportExportApi, workspaceWidgetRetryScanApi } from "../apis/AgencyApi";
import { showSnackbar } from "../slices/SnackbarSlice";
import { IPagination } from "../apis/AdminApis/AdminDataApi";

export interface ISetupAgency {
    name: string;
    logoUrl: string | null;
    smtp: {
        host: string;
        port: number;
        user: string;
        pass: string;
    };
    customDomain: string;
    privacyPolicyUrl?: string | null;
    termsOfConditionUrl?: string | null;
    setup_call_link?: string | null;
}

export interface ITestSMTP {
    host: string;
    port: number;
    user: string;
    pass: string;
}

export const getAgencyAction = createAsyncThunk("agency", async (_, { rejectWithValue, dispatch }) => {
    try {
        const response = await getAgencyApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Get agency failed" });
    }
})
export const SetupAgencyAction = createAsyncThunk("agency/setup", async (payload: ISetupAgency, { rejectWithValue, dispatch }) => {
    try {
        const response = await SetupAgencyApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Setup agency failed" });
    }
})
export const testSMTPAction = createAsyncThunk("agency/testSMTP", async (payload: string, { rejectWithValue, dispatch }) => {
    try {
        const response = await testSMTPApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Test SMTP failed" });
    }
})
export const validateSMTPAction = createAsyncThunk("agency/validateSMTP", async (payload: ITestSMTP, { rejectWithValue, dispatch }) => {
    try {
        const response = await validateSMTPApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Test SMTP failed" });
    }
})

export const VerifyDomainAction = createAsyncThunk("agency/verify-domain", async (domain: string, { rejectWithValue, dispatch }) => {
    try {
        const response = await VerifyDomainApi(domain)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Verify domain failed" });
    }
})

export const UpdateAgencyAction = createAsyncThunk("agency/update", async (payload: Partial<ISetupAgency>, { rejectWithValue, dispatch }) => {
    try {
        const response = await UpdateAgencyApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Update agency failed" });
    }
})

export const getWorkspaceWidgetDataAction = createAsyncThunk("workspace/widgetData", async (_, { rejectWithValue, dispatch }) => {
    try {
        const response = await getWorkspaceWidgetDataApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Get workspace widget data failed" });
    }
})

export const createWorkspaceWidgetDataAction = createAsyncThunk("workspace/createWidgetData", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await createWorkspaceWidgetDataApi(payload)
        dispatch(showSnackbar({ message: "Widget configuration saved successfully", type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "Failed to save widget configuration", type: "error" }));
        return rejectWithValue(error || { message: "Create workspace widget data failed" });
    }
})
export const updateWorkspaceWidgetDataAction = createAsyncThunk("workspace/updateWidgetData", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await updateWorkspaceWidgetDataApi(payload)
        dispatch(showSnackbar({ message: "Widget configuration updated successfully", type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "Failed to update widget configuration", type: "error" }));
        return rejectWithValue(error || { message: "Update workspace widget data failed" });
    }
})

export const workspaceWidgetReportDataAction = createAsyncThunk("workspace/widgetReportData", async (payload: IPagination, { rejectWithValue, dispatch }) => {
    try {
        const response = await workspaceWidgetReportDataApi(payload)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Get workspace widget report data failed" });
    }
})

export const workspaceWidgetRetryScanAction = createAsyncThunk("workspace/widgetRetryScan", async (payload: string, { rejectWithValue, dispatch }) => {
    try {
        const response = await workspaceWidgetRetryScanApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Retry scan failed" });
    }
})

export const workspaceWidgetReportExportAction = createAsyncThunk("workspace/widgetReportExport", async (_, { rejectWithValue, dispatch }) => {
    try {
        const response = await workspaceWidgetReportExportApi()
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Export report failed" });
    }
})

// Workspace-based white label actions
export const workspaceDetailsAction = createAsyncThunk("workspace/details", async (_, { rejectWithValue, dispatch }) => {
    try {
        const response = await workspaceDetailsApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Get workspace details failed" });
    }
})

export const workspaceUpdateAction = createAsyncThunk("workspace/update", async (payload: Partial<ISetupAgency>, { rejectWithValue, dispatch }) => {
    try {
        const response = await workspaceUpdateApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Update workspace failed" });
    }
})

export const workspaceVerifyDomainAction = createAsyncThunk("workspace/verify-domain", async (domain: string, { rejectWithValue, dispatch }) => {
    try {
        const response = await workspaceVerifyDomainApi(domain)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Verify domain failed" });
    }
})

export const workspaceValidateSMTPAction = createAsyncThunk("workspace/validate-smtp", async (payload: ITestSMTP, { rejectWithValue, dispatch }) => {
    try {
        const response = await workspaceValidateSMTPApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Validate SMTP failed" });
    }
})

export const workspaceTestEmailAction = createAsyncThunk("workspace/test-email", async (payload: string, { rejectWithValue, dispatch }) => {
    try {
        const response = await workspaceTestEmailApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Test email failed" });
    }
})

